import * as C from '../common/constants';
import { useSelector, useDispatch } from 'react-redux';
import { useRef } from 'react';
import {
  EffectComposer,
  ToneMapping,
  SelectiveBloom,
} from '@react-three/postprocessing';
import { ToneMappingMode, Resizer, KernelSize } from 'postprocessing';

const Bloom = ({ bulbRedRef, bulbGreenRef }) => {
  const isLightsOn = useSelector((state: any) => state.app[C.SET_WINGLIGHT]);

  const ambientLightRef = useRef(null);

  if (!isLightsOn) {
    return null;
  }

  // if (
  //   !ambientLightRef?.current ||
  //   !bulbRedRef?.current ||
  //   !bulbGreenRef?.current
  // ) {
  //   return null;
  // }

  return (
    <>
      <ambientLight
        position={[0, 1, 1]}
        intensity={10}
        ref={ambientLightRef}
        color={0x333333}
      />
      <EffectComposer disableNormalPass>
        <SelectiveBloom
          lights={[ambientLightRef]}
          selection={[bulbRedRef, bulbGreenRef]}
          mipmapBlur
          luminanceThreshold={1}
          luminanceSmoothing={0.025}
          levels={20}
          intensity={1}
          // kernelSize={KernelSize.LARGE}
        />
        <ToneMapping mode={ToneMappingMode.ACES_FILMIC} />
      </EffectComposer>
    </>
  );
};

export default Bloom;

// disableNormalPass
